export default "__VITE_ASSET__BDiYy2LP__"